import qs from 'query-string'

export function parseQuery() {
  return qs.parseUrl(window.location.href).query
}

export const checkLogin = (permits: any): boolean =>
  (process.env.NODE_ENV === 'production' && !!permits) || process.env.NODE_ENV === 'development'

export const timestamp2Date = (timestamp: number): String => {
  let time = new Date(timestamp)
  let year = time.getFullYear()
  let month = (time.getMonth() + 1).toString().padStart(2, '0')
  let date = time.getDate().toString().padStart(2, '0')
  return year + '-' + month + '-' + date
}

export const getTableIndex = (index: number): string => {
  if (index < 9) {
    return '0' + (index + 1)
  }
  return (index + 1).toString()
}

export const ObsKeyToURL = (key: string): string => {
  if (key !== '') {
    return `https://${process.env.REACT_APP_HW_BUCKET}.${process.env.REACT_APP_HW_SERVER}/${key}`
  }
  return ''
}

export const DownloadFile = ({name, suffix, url}) => {
  let x = new XMLHttpRequest()
  x.open('get', ObsKeyToURL(url))
  x.responseType = 'blob'
  x.onload = function (e) {
    let u = window.URL.createObjectURL(x.response)
    let a = document.createElement('a')
    a.href = u
    a.download = `${name}.${suffix}`
    a.click()
  }
  x.send()
}

export const getCourseAnnexType = (suffix: string) => {
  switch (suffix) {
    case 'doc':
    case 'docx':
    case 'pdf':
      return {name: '教案', value: 'lesson_plan'}
    case 'ppt':
    case 'pptx':
      return {name: '课件', value: 'courseware'}
    case 'mp4':
      return {name: '视频', value: 'video'}
    default:
      return {name: '', value: ''}
  }
}

export const getShortDateStr = (str: string) => {
  return str.substring(0, str.indexOf('T'))
}

export const hideOutline = (id: number) => {
  switch (id) {
    case 27:
    case 28:
    case 29:
    case 33:
      return true
    default:
      return false
  }
}
export const getLessonCount = (duration: string) => {
  switch (duration) {
    case '45min':
      return 1
    case '5*45min':
    case '5* 45min':
      return 5
    case '90min':
      return 2
    default:
      return 0
  }
}
